module.exports = __webpack_public_path__ + "static/media/ForeignCities.2227332a.svg";